const testDummy = {
  "nombre": "Mi primer test",
  "descripcion": "Descripción del test",
  "tipo": 1,
  "categoria_id": 1,
  "estado": 0,
  "dimensiones" : [
    {"id": 1, "nombre": "Valentía", "descripcion": "Descripción dimension 1", "puntos_min": 0,"puntos_max": 10,
        "diagnosticos": [ {"from": 0, "to": 5, "descripcion": "Resulta que bla bla bla"}]
  
  },
    {"id": 2, "nombre": "Coraje", "descripcion": "Descripción dimension 2", "puntos_min": 0,"puntos_max": 10},
    {"id": 3, "nombre": "Amor", "descripcion": "Descripción dimension 2", "puntos_min": 0,"puntos_max": 10},
    {"id": 4, "nombre": "Sinceridad", "descripcion": "Descripción dimension 2", "puntos_min": 0,"puntos_max": 10}
  ],

  "secciones": [
    {
      "id": 1,
      "nombre": "Primera sección",
      "descripcion": "Descripción de la sección 1",
      "dimension_id": 1
    },

    {
      "id": 2,
      "nombre": "Segunda sección",
      "descripcion": "Descripción de la sección 2",
      "dimension_id": 1
    }
  ],

  "preguntas": [
      {"id": 1, "seccion_id": 1, "dimension_id": 1, "modo_puntuacion": "directo", "peso": 1, "text": "¿Cómo estás?"},
      {"id": 2, "seccion_id": 1, "dimension_id": 1, "modo_puntuacion": "inverso", "peso": 1, "text": "¿Qué has comido hoy?"},
      {"id": 3, "seccion_id": 1, "dimension_id": 1, "modo_puntuacion": "directo", "peso": 1, "text": "¿Estás contento?"},
      {"id": 4, "seccion_id": 2, "dimension_id": 1, "modo_puntuacion": "directo", "peso": 1, "text": "¿Estás triste?"}
  ],

  /*Puntuación mode:  directo => correlación directa con los puntos de las respuestas
                      inverso => correlación inversa con los puntos de las respuestas 
    Peso: Puede que haya preguntas que tengas más peso que otras                    
  */

  "respuestas": [
      {"id": 1, "seccion_id": 1, "pregunta_id": null, "text": "Si primera secc", "puntos": 1},
      {"id": 2, "seccion_id": 1, "pregunta_id": null, "text": "No se primera secc", "puntos": 1},
      {"id": 3, "seccion_id": 2, "pregunta_id": null, "text": "Por supuesto segund secc", "puntos": 1},
      {"id": 4, "seccion_id": 2, "pregunta_id": null, "text": "Claro segunda secc", "puntos": 1}
  ],

  "leyendas": [
      {"id": 1, "seccion_id": 1, "text": "Muy descontento", "longitud": "3", "alineacion": "left" },
      {"id": 2, "seccion_id": 1, "text": "Muy contento", "longitud": "3", "alineacion": "left"},
      {"id": 3, "seccion_id": 1, "text": "No es verdad", "longitud": "3", "alineacion": "right"}
  ]

};

const testNew = {
  "nombre": "Nuevo test",
  "descripcion": "",
  "email_subject": "",
  "email_body": "",
  "send_email_result": false,
  "descripcion": "",
  "estado": "edición",      // Edición
  "privacidad": "privado",  // Privado
  "uso": "privado_url",         // Privado con url
  "uso_code": null,
  "tipo": 1,                        // Respuestas iguales por sección
  "tipo_resultado": "inmediato",    // Inmediato sin supervisión
  "categoria_id": null,
  "dimensiones_show": false,
  "dimensiones" : [],
  "secciones": [],
  "preguntas": [],
  "respuestas": [],
  "leyendas": [],
  "filtros": [],
};

const tipos =[ 
  {"value": 1, "text": "Todas las respuestas iguales"},
  {"value": 2, "text": "Respuestas diferentes por sección"},
  //{"value": 3, "text": "Respuestas diferentes por pregunta"},
];

const estados =[ 
  {"value": "edición",    "text": "Edición"},
  {"value": "finalizado", "text": "Finalizado"},
  {"value": "papelera",   "text": "Papelera"}
];

const privacidades =[ 
  {"value": "público",      "text": "Público"},
  {"value": "privado",      "text": "Privado"},
  {"value": "marketplace",  "text": "Marketplace"}
];

const usos =[ 
  {"value": "público", "text": "Público"},
  {"value": "privado_url", "text": "Privado conociendo la url"},
  {"value": "privado_password", "text": "Privado con usuario/password"}
];

// const categorias =[ 
//   {"id": 1, "nombre": "Psicológicos", "descripcion": "Descripción categoria psicológicos"},
//   {"id": 2, "nombre": "Altas capacidades", "descripcion":  "Descripción categoria altas capacidades"}
// ];


export { testDummy, testNew, tipos, estados, privacidades, usos }
